import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cc42bf3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toast-wrapper" }
const _hoisted_2 = { class: "toast-list" }
const _hoisted_3 = ["onHandleAnimationEnd"]

import { ref, onBeforeMount, onBeforeUnmount } from 'vue'
import { computed } from '@vue/reactivity'

import Text from '@/components/common/TextComponent.vue'
import { COLOR_SET } from '@/styles/variables'
import CheckMark from '@/styles/icon/CheckMark.vue'
import { isFacebook } from '@/utils/navigator'

import { getRefundList } from '../constants/refundList'


export default /*#__PURE__*/_defineComponent({
  name: 'RefundToast',
  setup(__props) {

_useCssVars(_ctx => ({
  "beb8b9be": (_unref(bottom))
}))

const dataQueue = ref<number[]>([])
const refundList = getRefundList()
const targetId = ref(0)
let startTimer: number
let initTimer: number

const setRandomTimer = () => {
  const min = 2
  const max = 7
  const rand = Math.floor(Math.random() * (max - min + 1) + min)
  const newId = (targetId.value + 1) > refundList.length ? 1 : (targetId.value + 1)
  targetId.value = newId
  dataQueue.value = [...dataQueue.value, targetId.value]
  if (dataQueue.value.length > 5) {
    dataQueue.value =  dataQueue.value.slice(-2)
  }
  startTimer = window.setTimeout(setRandomTimer, rand * 1000);
}

const getRefundTarget = (id: number) => {
  return refundList.find((item) => item.id === id)
}

const handleAnimationEnd = (target: number) => {
  dataQueue.value = dataQueue.value.filter((item) => item != target)
}

onBeforeMount(() => {
  initTimer = window.setTimeout(() => {
    setRandomTimer()
  }, 3000)
})

onBeforeUnmount(() => {
  if (startTimer) {
    clearInterval(startTimer)
  }
  if (initTimer) {
    clearInterval(initTimer)
  }
})

const bottom = computed(() => isFacebook() ? '170px' : '110px')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataQueue.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item,
          class: "toast",
          onHandleAnimationEnd: ($event: any) => (handleAnimationEnd(item))
        }, [
          _createVNode(CheckMark, {
            color: _unref(COLOR_SET).white
          }, null, 8, ["color"]),
          _createVNode(Text, {
            color: _unref(COLOR_SET).white,
            size: "14px",
            width: "max-content"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getRefundTarget(item)?.name) + " 대표님 " + _toDisplayString(getRefundTarget(item)?.amount) + " 환급신청 완료! ", 1)
            ]),
            _: 2
          }, 1032, ["color"])
        ], 40, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})